/* pending.icon.svg.js */

"use strict";
module.exports = {
    icon: `    
        <svg viewBox="0 0 20 20" preserveAspectRatio="none">
            <path class="foreground-gl" d="M10,19.86a9.9,9.9,0,1,1,9.9-9.9A9.91,9.91,0,0,1,10,19.86ZM10,1.44A8.52,8.52,0,1,0,18.5,10,8.53,8.53,0,0,0,10,1.44Z" transform="translate(-0.08 -0.05)"/><path class="foreground-gl" d="M10.25,10.85h-.14a.7.7,0,0,1-.48-.14C7.81,9.33,5.7,7.45,5.63,5l0-.73H14.7l0,.73c-.07,2.41-2.18,4.29-4,5.66A.71.71,0,0,1,10.25,10.85ZM7.16,5.73c.31,1.11,1.27,2.25,3,3.59,1.72-1.34,2.68-2.48,3-3.59Z" transform="translate(-0.08 -0.05)"/><path class="foreground-gl" d="M5.61,16.11l0-.73c.07-2.41,2.18-4.29,4-5.66a.72.72,0,0,1,.49-.14.71.71,0,0,1,.56.13c1.83,1.37,3.93,3.25,4,5.66l0,.73Zm4.55-5c-1.73,1.34-2.69,2.49-3,3.59h6C12.84,13.58,11.88,12.44,10.16,11.1Z" transform="translate(-0.08 -0.05)"/>
        </svg>
     `,
};
